import React from "react";
import Modal1 from "../../../../../components/DIsplay/Modal/Modal1";
import CancelTicket from "../../../../Orders/CancelTicket";

function ManageOrderCancelTicketModal({ booking, modal, setModal }) {
  return (
    <div>
      <Modal1
        open={modal.cancelTicket}
        setOpen={(modalState) =>
          setModal({ ...modal, cancelTicket: modalState })
        }
      >
        <CancelTicket
          data={booking}
          callback={() => {
            setModal({ ...modal, cancelTicket: false });
            setTimeout(() => {
              window.location.reload();
            }, 300);
          }}
          close={() => setModal({ ...modal, cancelTicket: false })}
        />
      </Modal1>
    </div>
  );
}

export default ManageOrderCancelTicketModal;
